import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitTargetPaymentAccount } from './variable-benefit-target-payment-account';

// accounts are in the drawdown order
export class VariableBenefitTargetPayment implements Deserializable {
  public targetRecurringPaymentAmount!: number;
  public totalMinimum!: number;
  public totalCeiling!: number;
  public placed!: number;
  public unplaced!: number;
  public belowMinimum!: boolean;
  public startsInALaterYear!: boolean;
  // The submit's refusal, word for word, or null when the submit would accept it
  public refusal!: string | null;
  public accounts: VariableBenefitTargetPaymentAccount[] = [];

  public onDeserialize(): void {
    this.accounts = window.injector.Deserialize.arrayOf(VariableBenefitTargetPaymentAccount, this.accounts ?? []);
  }
}
